import { fromJS, Map } from 'immutable';

export default {
    setBoxList: (state, boxes) => {
        let newBoxesState = fromJS(boxes);
        newBoxesState = newBoxesState.map((boxe, mac) => {
            if (state.hasIn(['list', mac])) return boxe.setIn(['fetched'], state.getIn(['list', mac, 'fetched']));
            return boxe;
        });
        return state.setIn(['list'], newBoxesState);
    },
    setBoxListFetched: (state, boxes) => {
        let newBoxesState = fromJS(boxes);
        newBoxesState = newBoxesState.map(boxe => {
            return boxe.setIn(['fetched'], true);
        });
        return state.mergeIn(['list'], newBoxesState);
    },
    setBoxListDetail: (state, boxMac, box) => {
        box.fetched = true;
        return state.mergeIn(['list', boxMac], fromJS(box));
    },
    resetBoxListDetail: state => {
        let boxList = state.get('list');
        boxList = boxList.map((boxe, boxMac) => {
            return new Map({ macAddress: boxMac });
        });
        return state.setIn(['list'], boxList);
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Boxes/core.js